import { endOfWeek, isWithinInterval, parseISO, startOfWeek } from "date-fns";
import type { MedicalCheckAssignment } from "@/lib/api";

const UPCOMING_MEDICAL_CHECK_STATUSES = new Set(["pending", "accepted", "attended"]);

export function getEmployeeUpcomingMedicalChecks(
  assignments: MedicalCheckAssignment[] | undefined,
  employeeId: string | number | null | undefined,
): MedicalCheckAssignment[] {
  const numericEmployeeId = Number(employeeId);
  if (!Number.isInteger(numericEmployeeId) || numericEmployeeId <= 0) return [];

  return (assignments ?? []).filter(
    (assignment) =>
      assignment.employeeId === numericEmployeeId
      && UPCOMING_MEDICAL_CHECK_STATUSES.has(assignment.status),
  );
}

export function getEmployeeMedicalChecksForWeek(
  assignments: MedicalCheckAssignment[] | undefined,
  employeeId: string | number | null | undefined,
  referenceDate = new Date(),
): Array<{ assignment: MedicalCheckAssignment; date: Date }> {
  const week = {
    start: startOfWeek(referenceDate, { weekStartsOn: 1 }),
    end: endOfWeek(referenceDate, { weekStartsOn: 1 }),
  };

  return getEmployeeUpcomingMedicalChecks(assignments, employeeId)
    .map((assignment) => ({
      assignment,
      date: parseISO(
        `${assignment.scheduledDate.slice(0, 10)}T${assignment.scheduledTime?.slice(0, 5) || "00:00"}:00`,
      ),
    }))
    .filter(({ date }) => !Number.isNaN(date.getTime()) && isWithinInterval(date, week));
}
